

import React, { useState } from 'react';

import * as S from './styles';

interface Props {
  classInfo: any,
  paperProps?: any,
  handleClose: () => void,
  anchorEl: any,
  id: any
}

const ClassHint = ({ classInfo, paperProps, handleClose, anchorEl }: Props) => {
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const getBooleanLabel = (obj, key) => {
    if (obj && obj[key]) {
      return 'yes';
    } else if (obj && !obj[key]) {
      return 'no';
    }
  };
  return (
    <S.PopoverWrap
      PaperProps={paperProps}
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
    >
      <S.HintWrap>
        <S.HintHeader>Klassen-Information</S.HintHeader>
        <S.HintRow>
          <S.HintItem>
            <p className="label">Lehrperson</p>
            <strong>{classInfo?.teacherName}</strong>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Schulbus</p>
            <span>
              {classInfo.schoolBus.length}
            </span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Max. SuS</p>
            <span>
              {classInfo?.maxStudentsNumber}
            </span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Min. SuS</p>
            <span>{classInfo?.minStudentsNumber}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Anzahl männlich</p>
            <span>{classInfo?.malesCount}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">
              Anzahl weiblich
            </p>
            <span>
              {classInfo?.femalesCount}
            </span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">
              Direktzuteilungen
            </p>
            <span>
              {classInfo?.directAssignmentCount}
            </span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Deutsch (gar kein / wenig)</p>
            <span>{classInfo?.lowGermanLevelCount}</span>
          </S.HintItem>
        </S.HintRow>
      </S.HintWrap >
    </S.PopoverWrap >
  );
};

export default ClassHint;
